module.exports = __webpack_public_path__ + "img/RoterPanda.184b48cc.jpg";